module.exports = __webpack_public_path__ + "img/arrow-90deg-down.902efcba.svg";